import { ck, cr } from "fire-wind-water";
import md5 from "js-md5";
import authService from "@/services/authService";
import { common } from "@/model/common";
import LangManager from "@/model/lang";

class RegisterModel {
  /**
   * 全局字段与自定义字段按 orderId 交错合并
   * orderId 语义: 自定义字段存它插入位置的全局字段序号(前面有多少个全局字段)
   */
  mergeCustomItems(items, customItems) {
    items = items || [];
    customItems = customItems || [];
    var byPos = {};
    customItems.forEach(function (c) {
      var pos = parseInt(c.orderId, 10);
      if (isNaN(pos) || pos < 0) {
        pos = items.length;
      }
      (byPos[pos] = byPos[pos] || []).push(c);
    });
    var merged = [];
    items.forEach(function (g, gIdx) {
      (byPos[gIdx] || []).forEach(function (c) {
        merged.push(c);
      });
      merged.push(g);
    });
    (byPos[items.length] || []).forEach(function (c) {
      merged.push(c);
    });
    return merged;
  }

  loadForm(self) {
    authService
      .getForm({
        schemaId: self.memberFormId,
        formId: self.memberFormId,
        memberFormId: self.memberFormId,
        isNotAdd: 1,
      })
      .then((data) => {
        self.formInfo = data.content;
        // 表单级自定义字段(编辑器格式)转成与 items 同构后并入,渲染与提交走现有链路
        let customItems = self.formInfo.customItems;
        if (Array.isArray(customItems) && customItems.length > 0) {
          let converted = customItems.map(function (item) {
            let options = (item.listOptions || []).map(function (
              optValue,
              idx
            ) {
              let conf = (item.otherList && item.otherList[idx]) || {};
              return {
                formId: item.formId,
                fieldName: item.fieldName,
                optionId: conf.index,
                optionValue: optValue,
                option: optValue,
                optionLabel: optValue,
                // sk-input 组件契约: isOther 标记"其他", otherisFillIn(小写i)/otherIsRequire 控制填空
                isOther: conf.isOther || 0,
                otherisFillIn: conf.isFillIn || 0,
                otherIsRequire: conf.isRequire || 0,
              };
            });
            item.required = parseInt(item.required);
            item.isLogin = 0;
            item.isSystemed = 0;
            item.fieldDisplayId = item.displayName;
            item.listOptions = options;
            item.options = options;
            return item;
          });
          self.formInfo.items = this.mergeCustomItems(
            self.formInfo.items,
            converted
          );
        }
        common.handPage(self.formInfo);
        window.$sk.template.update({
          type: "link",
          data: {
            identity: 1,
            weChatId: self.formInfo.authWeChatId || 0,
            skObjectType: "member",
            skObjectId: self.memberFormId,
            meetingInstanceId: "",
            meetingType: "",
            skIsNotLink: "",
            memberFormId: "",
          },
        });
        if (self.formInfo.authWeChatId) {
          self.weChatId = self.formInfo.authWeChatId;
        }
        this.getParamTree(self);
        window.$sk.loading.hide();
        if (self.afterLoadForm) self.afterLoadForm();
      });
  }

  getParamTree(self) {
    Promise.all(
      self.formInfo.items.map((item, index) => {
        item.required = parseInt(item.required);
        if (item.listOptionType == "DICT") {
          return authService
            .getParamTree({
              tenantId: common.tenantId,
              dicId: item.listDictId,
              format: "object",
            })
            .then((res) => {
              // item.dictInfo = res.content[item.listDictId];
              item.dictInfo = Object.values(res.content)[0];
              // i18n：字典选项翻译，保留中文原文 originalName 用于提交
              const lang = LangManager.current;
              const langKey = lang.toLowerCase();
              if (lang !== "zh_CN" && item.dictInfo) {
                item.dictInfo.forEach(function (opt) {
                  opt.originalName = opt.name;
                  if (opt.i18n && opt.i18n[langKey]) {
                    opt.name = opt.i18n[langKey];
                  } else if (opt[langKey]) {
                    opt.name = opt[langKey];
                  }
                });
              }
              self.$set(self.formList, index, item);
              // DICT 字段：watch listOptions 变化，用已翻译的 dictInfo 覆盖 optionLabel
              if (item.dictInfo && item.dictInfo.length > 0) {
                self.$watch(
                  function () {
                    var fi = self.formList[index];
                    return fi && fi.listOptions && fi.listOptions.length;
                  },
                  function () {
                    var fi = self.formList[index];
                    if (!fi || !fi.listOptions || !fi.dictInfo) return;
                    console.log(
                      "[i18n-debug] register-model watcher: fieldName=" +
                        fi.fieldName,
                      "listOptions=" + fi.listOptions.length,
                      "dictInfo=" + fi.dictInfo.length
                    );
                    for (
                      var i = 0;
                      i < fi.listOptions.length && i < fi.dictInfo.length;
                      i++
                    ) {
                      if (
                        fi.dictInfo[i].name &&
                        fi.listOptions[i].optionLabel !== fi.dictInfo[i].name
                      ) {
                        console.log(
                          "[i18n-debug] register-model [" +
                            i +
                            "] " +
                            fi.listOptions[i].optionLabel +
                            " -> " +
                            fi.dictInfo[i].name
                        );
                        fi.listOptions[i].optionLabel = fi.dictInfo[i].name;
                      }
                    }
                  },
                  { immediate: true }
                );
              }
            });
        } else {
          self.$set(self.formList, index, item);
        }
      })
    ).then(() => {
      self.isLoad = true;
      self.$nextTick(() => {
        cr.each(self.formList, (m) => {
          if (m.isLogin == 1 && m.result) {
            m.result.setAsyncError({
              key: "norepeat",
              message: `您输入的${m.displayName}已注册，请登录`,
              validator: () => {
                return new Promise((resolve) => {
                  authService
                    .checkUnique({
                      memberSchemaId: self.formInfo.schemaId,
                      unique:
                        m.isCallingCodeOpen == 1
                          ? m.value.code + m.result.value
                          : m.result.value,
                      fieldName: m.result.fieldName,
                    })
                    .subscribe((result) => {
                      console.log("result===", result);
                      resolve(result.content.result);
                    });
                });
              },
            });
          }
        });
      });
    });
  }

  register(self) {
    let answers = [];
    let needToken = false;
    self.isSubmitting = true;

    // ===== 日志：打印所有字段的提交值 =====
    console.log("===== [i18n-debug] 提交前所有字段值 =====");
    cr.each(self.formList, (item) => {
      var val = item.value;
      var displayVal = val && val.value !== undefined ? val.value : "(empty)";
      var displayLabel = item.displayName;
      console.log(
        "[i18n-debug] fieldName=" + item.fieldName,
        "displayName=" + displayLabel,
        "value=" + JSON.stringify(displayVal),
        "fieldType=" + item.fieldType,
        "listOptionType=" + (item.listOptionType || ""),
        item.result ? "result.value=" + JSON.stringify(item.result.value) : ""
      );
      // 如果有 listOptions，打印选项的 optionValue vs optionLabel
      if (item.listOptions && item.listOptions.length > 0) {
        var opts = item.listOptions.map(function (o) {
          return {
            optionValue: o.optionValue,
            optionLabel: o.optionLabel || o.optionValue,
          };
        });
        console.log("[i18n-debug]   listOptions:", JSON.stringify(opts));
      }
      if (item.dictInfo) {
        var dictOpts = item.dictInfo.map(function (o) {
          return {
            name: o.name,
            originalName: o.originalName || o.name,
            optionValue: o.optionValue,
            optionLabel: o.optionLabel,
          };
        });
        console.log("[i18n-debug]   dictInfo:", JSON.stringify(dictOpts));
      }
    });
    console.log("===== [i18n-debug] 提交值结束 =====");
    // ===== 日志结束 =====
    let submitData = {
      tenantId: self.formInfo.tenantId,
      schemaId: self.formInfo.schemaId,
      memberFormId: self.memberFormId,
      url: window.location.href,
      referenceUrl: self.inWeChat
        ? "微信"
        : document.referrer || window.location.href,
      token: self.token || "",
      verify: self.verify || "",
      sourceKey: common.sourceKey,
      globalUserId: common.globalUserId,
    };
    if (self.wx && self.wx.weChatId && self.wx.openId) {
      submitData.isBind = true;
      submitData.weChatId = self.wx.weChatId;
      submitData.openId = self.wx.openId;
    } else {
      if (self.inWeChat && (self.weChatId || self.backUrl)) {
        let weChatId = self.weChatId;
        if (!weChatId) {
          let url = decodeURIComponent(self.backUrl);
          let re = new RegExp("(^|&)" + "weChatId" + "=([^&]*)(&|$)", "i");
          let Parameter = url.match(re);
          if (Parameter !== null) {
            weChatId = Parameter[2];
          }
        }
        let wechatInfo = common.getVerifyInfo(weChatId);
        if (wechatInfo) {
          if (wechatInfo.original) {
            submitData.isBind = true;
            submitData.weChatId = weChatId;
            submitData.openId =
              wechatInfo.original.openid || wechatInfo.original.openId;
            submitData.verify = common.getVerify(weChatId);
          }
        }
      }
    }
    cr.each(self.formList, (item) => {
      let answer = {
        fieldName: item.fieldName,
        value: item.value.value,
      };
      if (item.fieldName === "password") {
        answer.value = md5(answer.value).toUpperCase();
      }
      if (item.fieldName === "enterprise") {
        answer.otherValue = item.value.otherValue;
        answer.thirdValue = item.value.thirdValue;
      }
      // 表单级自定义字段的"其他"填空: 组件校验后 item.value.otherValue 已是 [{选中值:填空}] 格式(对齐 tool)
      if (
        item.fieldLevel == 4 &&
        item.fieldType == "LIST" &&
        item.value &&
        Array.isArray(item.value.otherValue) &&
        item.value.otherValue.length > 0
      ) {
        answer.otherValue = item.value.otherValue;
      }
      answers.push(answer);
      if (item.fieldName == "mobile" && item.isSendSms == "1") {
        needToken = true;
        self.phone = item.value.value;
        submitData["verificationCode"] = item.value.checkCode;
      }
    });
    submitData["formData"] = answers;
    return new Promise((resolve, reject) => {
      if (needToken) {
        let params = {
          unique: self.phone,
          checkCode: submitData["verificationCode"],
          schemaId: self.formInfo.schemaId,
          formId: self.memberFormId,
          action: "register",
          globalUserId: common.globalUserId,
        };
        authService.getToken(params).then((data) => {
          if (data.result != 0) {
            self.isSubmitting = false;
            return window.$sk.tips.show(data["desc"]);
          }
          submitData.token = submitData.token
            ? [submitData.token, data.content.token]
            : data.content.token;
          this.registered(self, submitData, resolve, reject);
        });
      } else {
        this.registered(self, submitData, resolve, reject);
      }
    });
  }

  beforeRegisterHandler(self) {
    let inValid = true;
    self.formList = self.formList.map((item, index) => {
      item.checkFlag = !item.checkFlag;
      return self.$set(self.formList, index, item);
    });
    self.$nextTick(() => {
      // ===== 日志：校验结果 =====
      console.log("===== [i18n-debug] 校验结果 =====");
      self.formList.map((item) => {
        var val = item.value;
        console.log(
          "[i18n-debug] fieldName=" + item.fieldName,
          "displayName=" + item.displayName,
          "VerifyFail=" + (val ? val.VerifyFail : "no value"),
          "value=" + (val ? JSON.stringify(val.value) : "(empty)")
        );
        if (item.result && item.result.value !== undefined) {
          console.log(
            "[i18n-debug]   result.value=" + JSON.stringify(item.result.value)
          );
        }
      });
      console.log("===== [i18n-debug] 校验结果结束 =====");
      // ===== 日志结束 =====

      self.formList.map((item) => {
        if (item.value.VerifyFail) {
          return (inValid = false);
        }
      });
      if (!inValid) {
        return this.validationErrorHandler(self);
      }
      if (self.update) {
        self.update();
      } else {
        this.register(self);
      }
    });
  }

  validationErrorHandler(self) {
    //判断并找到第1个错误字段，并定位滚动到它的位置
    let anchor = self.$el.querySelector(".err");
    if (anchor) {
      document.body.scrollTop = anchor.offsetTop - 20;
      document.documentElement.scrollTop = anchor.offsetTop - 20;
    }
  }

  registered(self, submitData, resolve, reject) {
    authService.register(submitData).then(
      (data) => {
        if (data.result != 0) {
          self.isSubmitting = false;
          return window.$sk.tips.show(data["desc"]);
        }
        common.setSession(
          {
            session: data.content.sess,
            memberId: data.content.memberId,
          },
          7
        );
        this.afterRegisterHandler(self, data);
        resolve(data);
      },
      (data) => {
        this.afterRegisterHandler(self, data);
        reject(data);
      }
    );
  }

  afterRegisterHandler(self, data) {
    self.isSubmitting = false;
    if (data.result == "0") {
      if (self.afterRegisterHandler) {
        self.afterRegisterHandler(data);
      }
      let settingBackUrl;
      if (!self.backUrl) {
        let backUrlSetting = self.extras.backlink.href;
        settingBackUrl = RegExp("^https?:\\/\\/.+").test(backUrlSetting)
          ? backUrlSetting
          : "";
      }
      if (self.backUrl)
        self.backUrl = "模板配置的backUrl" + window.location.search; //todo
      if (self.backUrl || settingBackUrl) {
        if (self.backUrl) {
          common.handBackUrl(common.backUrl);
        } else {
          window.$sk.goto(settingBackUrl);
        }
      } else {
        common.routerPush(self, "loginSuccess");
      }
    } else {
      window.$sk.tips.show(data.desc);
    }
  }

  record(self) {
    authService
      .record({
        session: "",
        moduleId: "",
        memberId: "",
        cookieId: common.globalUserId,
        url: window.location.href,
        tenantId: self.formInfo.tenantId,
        openId: common.getOpenId(self.weChatId)
          ? common.getOpenId(self.weChatId)
          : "", //联系人openId
        weChatId: self.weChatId, //微信ID
        objId: self.memberFormId, //互动ID 例如表单ID 会议ID
        objTitle: self.formInfo.title, //互动名称   例如2017年的第一场会
        objInstanceId: "0",
        actionKey: "registerForm_browse", //互动行为key
        markCode: common.markCode || "",
        marketingSess: ck.cookie("marketingSess") || "",
      })
      .then(() => {});
  }
}

export const registerModel = new RegisterModel();
